<template>
  <v-container id="data-tables" tag="section">
    <base-material-card color="blue" icon="mdi-card-bulleted-outline" inline class="px-5 py-3">
      <v-spacer></v-spacer>
      <template v-slot:after-heading></template>
      <!-- Texto del boton NUEVO -->
      <template v-slot:corner-button>
        <v-btn small class="ma-2" elevation="2" color="blue" @click.stop="dialog = true"
          >Nueva Cuenta</v-btn
        >
      </template>

      <!-- <v-overlay :value="overlay">
        <v-progress-circular :size="50" color="green" indeterminate></v-progress-circular>
      </v-overlay> -->

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Búsqueda"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <!-- Empieza Dialogo Cancelar -->
      <ConfirmationDialog v-model="isSure" @click="cancel" />
      <!-- Termina Dialogo Cancelar -->
      <!-- Empieza Dialogo -->
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <!-- Campo CUENTA -->
                <v-col cols="6">
                  <v-text-field
                    v-model="$v.editedItem.cta_clave.$model"
                    label="Cuenta Clave"
                    counter="25"
                    dense
                    required
                    :error-messages="cta_claveErrors"
                    @input="$v.editedItem.cta_clave.$reset(), (changed = true)"
                    @blur="$v.editedItem.cta_clave.$touch()"
                  ></v-text-field>
                </v-col>
                <!-- Campo RETENCION -->
                <v-col cols="6">
                  <v-select
                    v-model="$v.editedItem.id_tipo_reten.$model"
                    :items="retenciones"
                    :menu-props="{ top: true, offsetY: true }"
                    label="Retenciones*"
                    item-text="reten_nombre"
                    item-value="id_tipo_reten"
                    persistent-hint
                    dense
                    hint="Seleciona Retención"
                    return-object
                    :error-messages="id_tipo_retenErrors"
                    @input="changed = true"
                    @blur="$v.editedItem.id_tipo_reten.$touch()"
                  >
                  </v-select>
                </v-col>
                <!-- Campo ENTIDAD -->
                <v-col cols="12">
                  <v-select
                    v-model="$v.editedItem.id_entidad.$model"
                    :items="entidades"
                    :menu-props="{ top: true, offsetY: true }"
                    label="Entidades*"
                    item-text="ent_nombre"
                    item-value="id_entidad"
                    persistent-hint
                    dense
                    hint="Seleciona Entidad"
                    return-object
                    :error-messages="id_entidadErrors"
                    @input="changed = true"
                    @blur="$v.editedItem.id_entidad.$touch()"
                  >
                  </v-select>
                </v-col>
                <!-- Campo CUENTA NOMBRE -->
                <v-col cols="6">
                  <v-text-field
                    v-model="editedItem.cta_nombre"
                    label="Cuenta Nombre"
                    counter="100"
                    dense
                    @input="$v.editedItem.cta_nombre.$reset(), (changed = true)"
                    @blur="$v.editedItem.cta_nombre.$touch()"
                  ></v-text-field>
                </v-col>
                <!-- Campo ACTIVO -->
                <v-col cols="12">
                  <v-checkbox
                    v-model="editedItem.cta_activo"
                    :label="`Estatus: ${
                      editedItem.cta_activo.toString() == 'true' ? 'Activo' : 'Inactivo'
                    }`"
                    @input="$v.editedItem.cta_activo.$reset(), (changed = true)"
                    @blur="$v.editedItem.cta_activo.$touch()"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-container>
            <small>*Campo Obligatorio</small>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-checkbox v-model="checkbox" label="Crear otro" :disabled="isEditing"></v-checkbox>
            <v-btn color="red darken-1" text @click="checkChanges">Cancelar</v-btn>
            <v-btn color="blue darken-1" text @click="save" :disabled="$v.$invalid">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Termina Dialogo -->
      <!-- Aqui va progress linear -->
      <v-divider class="mt-3" />
      <v-data-table
        :headers="headers"
        :items="cuentas"
        dense
        :search.sync="search"
        :loading="isLoading"
        loading-text="Cargando... Espere por favor"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>

        <!-- Creo el boton de Activo-->
        <template v-slot:item.cta_activo="{ item }">
          <Status :activostr="item.cta_activo" tipo="String" />
        </template>

        <template v-slot:no-data>
          <!-- <v-btn color="primary">Reset</v-btn> -->
          ¡No hay datos para mostrar!
        </template>
      </v-data-table>
      <!-- Termina Tabla de cuentas -->
      <!-- Empieza DataExporter -->
      <DataExporter :dataArray="cuentas" :dataFields="fields" fileName="cuentas" />
      <!-- Termina DataExporter -->
    </base-material-card>
  </v-container>
</template>

<script>
import ConfirmationDialog from '@/components/general/ConfirmationDialog.vue'
import Status from '@/components/general/StatusInfo.vue'
import { getValidToken } from '@/store/helpers.js'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import DataExporter from '@/components/general/DataExporter.vue'
export default {
  components: {
    ConfirmationDialog,
    Status,
    DataExporter,
  },

  data: () => ({
    search: undefined,
    isLoading: false,
    checkbox: false,
    isEditing: false,
    dialog: false,
    isSure: false,
    overlay: false,
    changed: false,
    headers: [
      { text: 'Id', align: 'start', sortable: false, value: 'id_cta' },
      { text: 'Cuenta', value: 'cta_clave' },
      { text: 'Entidad', value: 'ent_nombre' },
      { text: 'Retención', value: 'reten_nombre' },
      { text: 'Activo', value: 'cta_activo' },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],
    //
    value: [],
    entidades: [],
    retenciones: [],
    cuentas: [],
    tipos: [],
    editedIndex: -1,
    editedItem: {
      id_cta: 0,
      id_tipo: 0,
      cta_clave: '',
      //tipo: { id_tipo: 0, cta_clave: '' },
      ent_nombre: '',
      reten_nombre: '',
      cta_nombre: '',
      cta_activo: true,
    },
    defaultItem: {
      id_cta: 0,
      id_tipo: 0,
      cta_clave: '',
      //tipo: { id_tipo: 0, cta_clave: '' },
      ent_nombre: '',
      reten_nombre: '',
      cta_nombre: '',
      cta_activo: true,
    },
    //Para Exportar
    fields: {
      Entidad: 'id_cta',
      Tipo: 'cta_clave',
      Nombre: 'ent_nombre',
      Activo: 'cta_activo',
    },
  }),

  mixins: [validationMixin],
  //Validaciones para los campos del formulario
  validations: {
    editedItem: {
      //ent_nombre: { required, minLength: minLength(3), maxLength: maxLength(255) },
      cta_clave: { required, minLength: minLength(3), maxLength: maxLength(25) },
      //id_tipo: { required, minLength: minLength(3), maxLength: maxLength(255) },
      //reten_nombre: { required, minLength: minLength(3), maxLength: maxLength(100) },
      id_tipo_reten: { required },
      id_entidad: { required },
    },
  },

  computed: {
    //Titulo de los formularios
    formTitle() {
      return this.editedIndex === -1 ? 'Nueva Entidad' : 'Editar Entidad'
    },
    cta_claveErrors() {
      const errors = []
      if (!this.$v.editedItem.cta_clave.$dirty) return errors
      !this.$v.editedItem.cta_clave.required && errors.push('Este campo es requerido')
      !this.$v.editedItem.cta_clave.minLength &&
        errors.push('Este campo debe de tener un mínimo de 3 caracteres.')
      !this.$v.editedItem.cta_clave.maxLength &&
        errors.push('Este campo debe de tener un máximo de 20 caracteres.')
      return errors
    },
    id_tipo_retenErrors() {
      const errors = []
      if (!this.$v.editedItem.id_tipo_reten.$dirty) return errors
      !this.$v.editedItem.id_tipo_reten.required && errors.push('Este campo es requerido')
      return errors
    },
    id_entidadErrors() {
      const errors = []
      if (!this.$v.editedItem.id_entidad.$dirty) return errors
      !this.$v.editedItem.id_entidad.required && errors.push('Este campo es requerido')
      return errors
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },
  //1ero
  created() {
    this.iniciando()
  },

  methods: {
    //Refresca Datos para la tabla
    async iniciando() {
      let jwt = await getValidToken(this)
      this.obtenerRetenciones(jwt)
      this.obtenerEntidades(jwt)
      this.obtenerCuentas(jwt)
    },
    //Obtiene todos laas Retenciones para el select
    async obtenerRetenciones(jwt) {
      this.isLoading = true
      //let jwt = await getValidToken(this)
      if (jwt != null) {
        let payload = { jwt: jwt }
        this.$store
          .dispatch('retencion/fetchRetencion', payload)
          .then((response) => {
            this.retenciones = response.data
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.error,
              // Enviar a inicio de sesión
            })
          })
      }
    },
    //Obtiene todos laas Retenciones para el select
    async obtenerEntidades(jwt) {
      this.isLoading = true
      //let jwt = await getValidToken(this)
      if (jwt != null) {
        let payload = { jwt: jwt }
        this.$store
          .dispatch('entidad/fetchEntidad', payload)
          .then((response) => {
            this.entidades = response.data
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.error,
              // Enviar a inicio de sesión
            })
          })
      }
    },
    //Obtiene Todos las Entidades para la tabla
    async obtenerCuentas(jwt) {
      this.isLoading = true
      //let jwt = await getValidToken(this)
      if (jwt != null) {
        let payload = { jwt: jwt }
        this.$store
          .dispatch('cuenta/fetchCuenta', payload)
          .then((response) => {
            this.cuentas = response.data
            this.isLoading = false
          })
          .catch((err) => {
            this.isLoading = false
            this.$store.commit('ALERT', {
              color: 'error',
              text: err.response.data.error,
              // Enviar a inicio de sesión
            })
          })
      }
    },
    // Editar Tipo
    editItem(item) {
      this.isEditing = true
      this.editedIndex = this.cuentas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.cta_activo = this.editedItem.cta_activo == 1 ? true : false
      this.dialog = true
    },
    // Eliminar Tipo
    deleteItem(item) {
      const index = this.cuentas.indexOf(item)
      //Confirma cerrar formulario
      confirm('Esta seguro que desea eliminar este registro?') && this.cuentas.splice(index, 1)
      this.Borrar(item.id_cta)
    },
    //Borrar en BD es desActivar
    async Borrar(index) {
      this.overlay = true
      this.$v.$touch()

      let body = {
        //_id: this.editedItem.id_tipo,
        id_cta: index,
        //cta_clave: this.editedItem.cta_clave,
        cta_activo: 0,
      }
      let jwt = await getValidToken(this)
      let payload = { jwt: jwt, body: body }
      payload.id = index
      this.$store
        .dispatch('entidad/deleteEntidad', payload)
        .then(() => {
          this.$store.commit('ALERT', {
            color: 'success',
            text: 'El registro se eliminó con éxito',
          })
          this.overlay = false
        })
        .catch((err) => {
          this.$store.commit('ALERT', {
            color: 'error',
            text: err.response.data.msg,
            // Enviar a inicio de sesión
          })
          this.overlay = false
        })
      Object.assign(this.cuentas[this.editedIndex], this.editedItem)
    },
    // Revisar los cambios en el formulario
    checkChanges() {
      if (this.changed) {
        this.isSure = true
      } else {
        this.close(false)
        this.changed = false
      }
    },

    cancel(isSure) {
      this.isSure = isSure
      if (this.isSure) {
        this.close(false)
        this.changed = false
      }
    },

    // Cerrar el formulario
    close(checkbox) {
      this.isSure = false
      this.checkbox = checkbox
      if (!this.checkbox) {
        this.dialog = false
        this.isEditing = false
      }
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
      this.$v.$reset()
    },

    // Guardar el formulario
    async save() {
      this.overlay = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let tipo = 0
        if (this.editedItem.id_tipo.id_tipo == null) {
          tipo = this.editedItem.id_tipo
        } else {
          tipo = this.editedItem.id_tipo.id_tipo
        }
        let body = {
          //id_tipo: this.editedItem.id_tipo,
          //id_tipo: this.editedItem.id_tipo.id_tipo,
          id_tipo: tipo,
          ent_nombre: this.editedItem.ent_nombre,
          reten_nombre: this.editedItem.reten_nombre,
          cta_activo: this.editedItem.cta_activo == true ? 1 : 0,
        }
        console.log(tipo)
        //console.log(body)

        let jwt = await getValidToken(this)
        let payload = { jwt: jwt, body: body }
        if (this.editedIndex > -1) {
          payload.id = this.editedItem.id_cta
          this.$store
            .dispatch('entidad/editEntidad', payload)
            .then(() => {
              this.$store.commit('ALERT', {
                color: 'success',
                text: 'El registro se actualizo con éxito',
              })
              this.overlay = false
            })
            .catch((err) => {
              this.$store.commit('ALERT', {
                color: 'error',
                text: err.response.data.msg,
                // Enviar a inicio de sesión
              })
              this.overlay = false
            })
          Object.assign(this.cuentas[this.editedIndex], this.editedItem)
        } else {
          this.$store
            .dispatch('entidad/addEntidad', payload)
            .then((response) => {
              this.$store.commit('ALERT', {
                color: 'success',
                text: 'El registro se creó con éxito',
              })
              this.cuentas.push(response.data)
              this.overlay = false
            })
            .catch((err) => {
              this.$store.commit('ALERT', {
                color: 'error',
                text: err.response.data.msg,
                // Enviar a inicio de sesión
              })
              this.overlay = false
            })
        }
        this.close(this.checkbox)
        this.changed = false
        jwt = await getValidToken(this)
        this.obtenerCuentas(jwt)
      }
    },
  },
}
</script>
